import UAParser from 'ua-parser-js'

let parser = new UAParser()
let parserResults = parser.getResult()
export const isAndroid = parserResults.os.name === 'Android[-x86]' || parserResults.os.name === 'Android'
export const isIOS = parserResults.os.name === 'iOS'
export const isSafari = parserResults.browser.name === 'Safari'
export const isMobile = parserResults.device.type === 'mobile' || parserResults.device.type === 'tablet'